<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" style="overflow-y: scroll;" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <div class="vx-card p-6">
        <div class="flex flex-wrap" style="font-size: 15px; justify-content: center; margin-top: 10px;">
          ÜRÜN DEĞERLENDİRME FORMU
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-full mt-10">
            <label class="text-sm"><b>Ürün değerlendirmeleri </b></label>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-10">
            {{ commentPost[0].productName }}
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-full mt-10">
            <label class="text-sm"><b>Lütfen bir değerlendirme yapınız</b></label>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-full mt-10">
            <label class="text-sm"><b>Derecelendirmeniz ?</b></label>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-10">
            <star-rating v-model="commentPost[0].rating" :star-size="20"></star-rating>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-full mt-10">
            <label class="text-sm"><b>Derecelendirmeniz için başlık *</b></label>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-10">
            <vs-input v-model="commentPost[0].title" v-validate="'required'" size="small" class="w-full" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-full mt-10">
            <label class="text-sm"><b>Ürünle ilgili düşünceleriniz *</b></label>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-textarea v-model="commentPost[0].comment" v-validate="'required'" name="comment" class="w-full mb-0 mt-5" />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-full mt-10"></div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-button class="w-full" @click="saveCustomerComment()">Değerlendirmeyi Gönder</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { anonymousService } from "../../_services/anonymous.service";
import StarRating from "vue-star-rating";
import customerComment from "../crm/customerComment.vue";

export default {
  components: {
    StarRating,
    customerComment,
  },
  data() {
    return {
      ErrorShow: false,
      checkbox_remember_me: false,
      mail: "",
      password: "",
      messageText: "",
      orderKey: "",
      commentPost: [{ productName: null, productId: null, rating: 5, title: null, comment: null }],
      commentList: [],
    };
  },
  async created() {
    this.$vs.loading();
    await this.getCustomerCommentForm();
    this.commentPost[0].rating = 5;
    this.$vs.loading.close();
  },
  methods: {
    getCustomerCommentForm: async function() {
      let keyParam = this.$route.params.key;
      let result = await anonymousService.generateCustomerCommentForm(keyParam);
      this.commentPost = result.list;
    },

    saveCustomerComment: async function() {
      if (this.commentPost[0].title && this.commentPost[0].comment) {
        let resultConfirm = await this.$swal.fire({
          icon: "warning",
          text: `${this.commentPost[0].productName} Yorumunuz gönderilecektir emin misiniz?`,
          // text: "Devam etmek istediğinize emin misiniz?",

          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });

        if (resultConfirm.isConfirmed) {
          this.$vs.loading();
          await anonymousService.saveCustomerComment(this.commentPost[0]);
          this.$vs.loading.close();
          await this.$swal.fire(`Yorumunuz için çok teşekkür ederiz.`);
          window.close();
        }
      } else {
        await this.$swal.fire(`Lütfen başlık ve mesaj bölümünü doldurunuz.`);
      }
     
    },
  },
};
</script>
